import React from "react";
import { TabsProps, TabPaneProps } from "antd/lib/tabs";
import { Tabs } from "antd";

interface TabsComponentProps extends TabsProps {}
const TabsComponent = (props: TabsComponentProps) => {
  return <Tabs {...props} />;
};

interface TabPaneComponent extends TabPaneProps {}
const TabPaneComponent = (props: TabPaneComponent) => {
  return <Tabs.TabPane {...props} />;
};
export { TabsComponent, TabPaneComponent };
